import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_8: FaireProductEntity = {
  token: "plant-dyed-8",
  type: "product",
  name: "Desert Gold Classic Print",
  brandName: "Eco Raw Studio",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/33f1cdea78356494e3a0198942da85bfbeaee57819a71563c0bf4cb0b8d90337.png",
  priceDollars: 10.15,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/33f1cdea78356494e3a0198942da85bfbeaee57819a71563c0bf4cb0b8d90337.png",
  weight: 0.3,
  dimensions: {
    width: 18,
    height: 18,
    depth: 0.5,
  },
  description: "Desert gold classic print with plant-dyed textiles",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "print",
    "textile",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
